<template>
  <v-dialog persistent v-model="dialog" width="500">
    <v-card>
      <v-card-title>
        <v-layout class="mx-n2">
          <v-flex>
            <div>New Subscriber</div>
          </v-flex>
          <v-flex text-right>
            <v-btn icon @click="cancel">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-layout class="px-4 mb-3">
        <v-flex>
          <v-layout class="mt-3">
            <v-flex>
              <div class="subtitle-2 mb-1">Entity</div>
              <v-autocomplete
                :loading="loading"
                v-model="entity"
                :items="reviewedEntities"
                cache-items
                :search-input.sync="searchTerm"
                hide-details
                return-object
                item-text="title"
                item-value="title"
                placeholder="Select Entity"
                no-data-text="Type a name of an entity to search"
                outlined
                chips
                dense
                @change="updatePhoneNumber"
              ></v-autocomplete>
            </v-flex>
          </v-layout>
          <v-layout class="mt-3" v-if="entity">
            <v-flex>
              <div class="subtitle-2 mb-1">Phone Number</div>
              <v-text-field
                v-model="phone"
                hide-details
                dense
                outlined
                placeholder="Phone Number"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout class="mt-3">
            <v-flex>
              <div class="subtitle-2 mb-1">Contact Preference</div>
              <v-select
                dense
                outlined
                :items="preferences"
                v-model="preference"
                placeholder="Contact Preference"
              >
              </v-select>
            </v-flex>
          </v-layout>
          <v-layout align-center class="mt-3">
            <v-flex>
              <div class="subtitle-2 mb-1">Schedule</div>
            </v-flex>
            <v-flex text-right>
              <v-btn
                color="primary"
                class="text-none subtitle-2"
                @click="addDayTime"
              >
                Edit Schedule
              </v-btn>
            </v-flex>
          </v-layout>
          <!-- <v-layout>
            <v-flex>
              <div v-for="(item, i) in schedule" :key="i">
                {{ item }}
              </div>
            </v-flex>
          </v-layout> -->
          <v-layout class="mx-10 mt-3" v-if="schedule.length === 0">
            <v-flex text-center>
              <div class="body-2 grey--text text--darken-2">
                No Items in the schedule, click edit schedule to add items to
                the schedule.
              </div>
            </v-flex>
          </v-layout>
          <v-list class="px-0">
            <template v-for="(item, i) in schedule">
              <v-list-item class="px-0" :key="i">
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.day }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ iMoment(item.time) }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider :key="`divider-${i}`" />
            </template>
          </v-list>
        </v-flex>
      </v-layout>
      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="cancel"
          color="error"
          class="text-none subtitle-2"
          outlined
        >
          Cancel
        </v-btn>
        <v-btn color="primary" class="text-none subtitle-2" @click="save">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
    <schedule-dialog
      :dayTimeSchedule="schedule"
      @updateSchedule="updateSchedule"
      ref="scheduleDialogRef"
    />
  </v-dialog>
</template>

<script>
import _ from "lodash";
import { mapActions, mapState } from "vuex";
import ScheduleItem from "./ScheduleItem";
import ScheduleDialog from "./ScheduleDialog";
import moment from "moment";
export default {
  props: {
    collection: {
      type: String,
      default: function () {
        return {};
      },
    },
  },
  components: {
    // ScheduleItem,
    ScheduleDialog,
  },
  data() {
    return {
      searchTerm: "",
      loading: false,
      dialog: false,
      entity: "",
      phone: "",
      preference: "",
      schedule: [],
      preferences: ["phone", "text"],
    };
  },
  computed: {
    ...mapState("$_entity", ["reviewedEntities"]),
    changeFields() {
      return {
        entity: this.entity,
        entityId: this.entity.id,
        phone:
          this.entity.phone === this.phone ? this.entity.phone : this.phone,
        preference: this.preference,
        schedule: this.schedule,
        state: "active",
      };
    },
  },
  watch: {
    searchTerm: _.debounce(function (e) {
      e && this.searchEntities(e);
    }, 300),
  },
  methods: {
    ...mapActions({
      createNewSubscriber: "$_entity/createNewSubscriber",
      getSubscribers: "$_entity/getSubscribers",
      getEntities: "$_entity/getContent",
      searchEntitiesAction: "$_entity/searchContent",
    }),
    updatePhoneNumber() {
      this.phone = this.entity.phone;
    },
    iMoment(timestamp) {
      if (timestamp) {
        let temp = timestamp;
        return moment(temp, "HH:mm").format("LT");
      } else {
        return 0;
      }
    },
    updateSchedule(schedule) {
      this.schedule = schedule;
    },
    addDayTime() {
      this.$refs.scheduleDialogRef.toggleDialog();
      //   this.dayTimeDialog = true;
      //   this.schedule.push({
      //     day: 0,
      //     time: "",
      //   });
    },
    searchEntities(searchTerm) {
      this.loading = true;
      console.log("searching Tags: ", searchTerm);

      this.searchEntitiesAction({
        collection: "entities",
        mutation: "updateReviewedEntities",
        searchTerm: searchTerm,
      }).then(() => {
        this.loading = false;
      });
    },
    toggleDialog() {
      this.dialog = !this.dialog;
    },
    cancel() {
      this.entity = "";
      this.preference = "";
      this.schedule = [];

      this.dialog = false;
    },
    save() {
      console.log(this.changeFields);
      this.createNewSubscriber({
        details: this.changeFields,
        collection: this.collection,
        type: "subscriber",
      }).then(() => {
        this.cancel();
        this.getSubscribers({
          type: "subscriber",
          collection: this.collection,
          mutation: "updateSubscribers",
        });
      });
    },
  },
};
</script>

<style>
</style>

          